import { AlertTriangle, ExternalLink, FileImage, ShieldAlert } from 'lucide-react'

const guides = [
  {
    id: 'natural-healing-program',
    eyebrow: '참고자료 1',
    title: '암 자연 치유 프로그램',
    description: '하루 식사, 녹즙, 운동·스트레칭, 온열요법과 기타 참고·주의사항을 한 장에 담은 제공 자료입니다.',
    srcSet: '/images/reference-guides/natural-healing-program-960.webp 960w, /images/reference-guides/natural-healing-program-1440.webp 1440w',
    src: '/images/reference-guides/natural-healing-program-960.webp',
    full: '/images/reference-guides/natural-healing-program-1440.webp',
    width: 1449,
    height: 1965,
    alt: '사용자가 제공한 암 자연 치유 프로그램 안내 자료 원문 전체 이미지',
  },
  {
    id: 'cancer-patient-guide',
    eyebrow: '참고자료 2',
    title: '암 환우분을 위한 건기식 맞춤 섭취 안내',
    description: '1주차·2주차 섭취방법, 주의사항, 식사 후 진행 순서와 생활관리 팁을 담은 제공 자료입니다.',
    srcSet: '/images/reference-guides/cancer-patient-guide-720.webp 720w, /images/reference-guides/cancer-patient-guide-920.webp 920w',
    src: '/images/reference-guides/cancer-patient-guide-720.webp',
    full: '/images/reference-guides/cancer-patient-guide-920.webp',
    width: 921,
    height: 1290,
    alt: '사용자가 제공한 암 환우분을 위한 건기식 맞춤 섭취 안내 원문 전체 이미지',
  },
]

export function ReferenceGuidesPage() {
  return <div className="page reference-guides-page">
    <header className="page-title reference-title">
      <span className="eyebrow"><FileImage/> 제공받은 원문 자료</span>
      <h1>건강 참고자료</h1>
      <p>원문의 문구와 이미지 내용은 바꾸지 않고, 자료별로 구분해 더 쉽게 찾아볼 수 있도록 배치했습니다.</p>
    </header>

    <aside className="reference-safety" aria-label="참고자료 이용 안내">
      <ShieldAlert aria-hidden="true"/>
      <div><strong>이 자료는 사용자가 제공한 참고자료이며, 공식 제품 표시사항이나 의료진의 진료를 대신하지 않습니다.</strong><p>질병의 진단·치료 또는 섭취량을 결정할 때는 제품 포장과 공식 회사 페이지를 우선 확인하고 의료전문가와 상담하세요.</p></div>
    </aside>

    <nav className="reference-jump" aria-label="참고자료 바로가기">
      {guides.map((guide) => <a key={guide.id} href={`#${guide.id}`}>{guide.eyebrow}<strong>{guide.title}</strong></a>)}
    </nav>

    <div className="reference-grid">
      {guides.map((guide) => <article className="reference-card" id={guide.id} key={guide.id}>
        <header><span>{guide.eyebrow}</span><h2>{guide.title}</h2><p>{guide.description}</p></header>
        <a className="reference-image-link" href={guide.full} target="_blank" rel="noopener noreferrer" aria-label={`${guide.title} 큰 이미지로 보기`}>
          <picture><source srcSet={guide.srcSet} type="image/webp" sizes="(max-width: 760px) calc(100vw - 40px), 540px"/><img src={guide.src} alt={guide.alt} width={guide.width} height={guide.height} loading="lazy" decoding="async"/></picture>
          <span><ExternalLink aria-hidden="true"/> 눌러서 크게 보기</span>
        </a>
      </article>)}
    </div>

    <aside className="reference-caution"><AlertTriangle aria-hidden="true"/><p><strong>원문 보존 안내</strong> 위 이미지는 받은 자료의 내용을 수정하지 않았습니다. 자료에 적힌 주장과 섭취 안내는 이 앱이 검증하거나 권장한다는 뜻이 아닙니다.</p></aside>
  </div>
}
